import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=15c9ca8d"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=15c9ca8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports